import { render } from "./App.vue?vue&type=template&id=29011b4a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=29011b4a&lang=css"

import exportComponent from "D:\\Java Script Udemy Kurs\\VUE COURSE\\vue-form\\vue-form\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__